import React, { useEffect, useState } from "react";
import { ProjectAPI, BlobAPI } from "../services/api";
import { Blocks , RulerDimensionLine,SlidersHorizontal,
  Grid3x3,GitCompare ,FolderSync, FilePen , LogOut , HardHat,

} from "lucide-react";

type AppHeaderProps = {
  title: string;
  userName?: string | null;

  onBack: () => void;
  onHome: () => void;
  onLogout: () => void;

  activeTab: "home" | "dashboard" | "second" | "third" | "fourth"  | "fifth";

  onDashboard: () => void;
  onSecond: () => void;
  onThird: () => void;
  onFourth: () => void;

  onFifth: () => void;

  projectId?: number | null;
  onProjectUpdated?: (projectName: string) => void;
};

type EditFormState = {
  projectName: string;
  projectDescription: string;
  startDate: string;
  image: File | null;
  imageUrl: string;
  imagePreviewUrl: string;
};

const AppHeader = ({
  title,
  userName,
  onBack,
  onHome,
  onLogout,
  activeTab,
  onDashboard,
  onSecond,
  onThird,
  onFourth,

  onFifth,
  projectId,
  onProjectUpdated,
}: AppHeaderProps) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [loadingProject, setLoadingProject] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deletingImage, setDeletingImage] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  const [editForm, setEditForm] = useState<EditFormState>({
    projectName: "",
    projectDescription: "",
    startDate: "",
    image: null,
    imageUrl: "",
    imagePreviewUrl: "",
  });

  const user = JSON.parse(localStorage.getItem("user") || "{}");

const isSampleUser =
  user.email?.toLowerCase() === "hr@agilecivilengineers.com";


  const tabClass = (tab: "home" | "dashboard" | "second" | "third" | "fourth" | "fifth") =>
    `relative h-12 px-4  transition-colors duration-150 flex items-center gap-2 ${
      activeTab === tab
        /*  ? "text-white bg-[#070730]"
        : "text-gray-300 hover:text-white hover:bg-[#070730]"  */
         ? "text-white bg-[#53538c]"
      : "text-gray-300 hover:text-white hover:bg-[#53538c]"
         
    }`;

  const activeBar = (tab: "home" | "dashboard" | "second" | "third" | "fourth"  | "fifth") =>
    activeTab === tab ? (
      <span className="absolute left-1 right-1 bottom-2 h-[4px] bg-blue-400 rounded-full" />
    ) : null;

  const resetEditForm = () => {
    setEditForm((prev) => {
      if (prev.imagePreviewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(prev.imagePreviewUrl);
      }

      return {
        projectName: "",
        projectDescription: "",
        startDate: "",
        image: null,
        imageUrl: "",
        imagePreviewUrl: "",
      };
    });
  };

  const loadProjectImages = async (pid: number) => {
    setImageLoading(true);
    try {
      let url = "";
      let preview = "";

      try {
        url = await BlobAPI.get("Project", pid);
      } catch {
        url = "";
      }

      try {
        preview = await BlobAPI.getImage("Project", pid);
      } catch {
        preview = "";
      }

      setEditForm((prev) => {
        if (prev.imagePreviewUrl.startsWith("blob:")) {
          URL.revokeObjectURL(prev.imagePreviewUrl);
        }

        return {
          ...prev,
          imageUrl: url || "",
          imagePreviewUrl: preview || "",
        };
      });
    } finally {
      setImageLoading(false);
    }
  };

  const openEditProject = async () => {
    if (!projectId) return;

    try {
      setLoadingProject(true);

      const project = await ProjectAPI.getById(projectId);

      setEditForm((prev) => {
        if (prev.imagePreviewUrl.startsWith("blob:")) {
          URL.revokeObjectURL(prev.imagePreviewUrl);
        }

        return {
          projectName: project.projectName || "",
          projectDescription: project.projectDescription || "",
          startDate: project.startDate ? project.startDate.substring(0, 10) : "",
          image: null,
          imageUrl: "",
          imagePreviewUrl: "",
        };
      });

      await loadProjectImages(projectId);

      setShowEditModal(true);
    } catch (err) {
      console.error("LOAD PROJECT ERROR:", err);
      alert("Failed to load project details");
    } finally {
      setLoadingProject(false);
    }
  };

  const handleDeleteImage = async () => {
    if (!projectId) return;

    try {
      setDeletingImage(true);

      await BlobAPI.delete("Project", projectId, "project-images");

      setEditForm((prev) => {
        if (prev.imagePreviewUrl.startsWith("blob:")) {
          URL.revokeObjectURL(prev.imagePreviewUrl);
        }

        return {
          ...prev,
          image: null,
          imageUrl: "",
          imagePreviewUrl: "",
        };
      });

      alert("Image deleted successfully");
    } catch (err) {
      console.error("DELETE IMAGE ERROR:", err);
      alert("Image delete failed");
    } finally {
      setDeletingImage(false);
    }
  };

  const handleUpdateProject = async () => {
    if (!projectId) return;

    if (
      !editForm.projectName ||
      !editForm.projectDescription ||
      !editForm.startDate
    ) {
      alert("All fields are required");
      return;
    }

    try {
      setSaving(true);

      const formData = new FormData();
      formData.append("projectName", editForm.projectName);
      formData.append("projectDescription", editForm.projectDescription);
      formData.append("startDate", editForm.startDate);

      const result = await ProjectAPI.update(projectId, formData);

      if (editForm.image) {
        await BlobAPI.uploadFileOnly(editForm.image, {
          containerName: "project-images",
          entityType: "Project",
          entityNo: projectId,
          project: projectId,
          sno: 1,
        });

        await loadProjectImages(projectId);
      }

      const updatedName =
        result?.data?.projectName ||
        result?.projectName ||
        editForm.projectName;

      localStorage.setItem("projectName", updatedName);
      onProjectUpdated?.(updatedName);

      setShowEditModal(false);
      resetEditForm();

      alert("Project updated successfully");
    } catch (err) {
      console.error("UPDATE ERROR:", err);
      alert("Update failed");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    return () => {
      if (editForm.imagePreviewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(editForm.imagePreviewUrl);
      }
    };
  }, [editForm.imagePreviewUrl]);

  return (
    <>
     
      <header
  //className="h-12 bg-[#070730] text-white flex items-center justify-between px-4 border-b border-gray-700"
  //className="h-12 bg-[#53538c] text-white flex items-center justify-between px-4 border-b border-gray-700"
    className="h-12 bg-[#53538c] text-white flex items-center justify-between px-4 border-b border-gray-700"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>
        <div className="flex items-center gap-4 min-w-0">
          <button
            onClick={onBack}
            //className="h-8 w-8 flex items-center justify-center rounded-sm text-gray-300 hover:text-white hover:bg-[#070730] transition"
            className="h-8 w-8 flex items-center justify-center rounded-sm text-gray-300 hover:text-white hover:bg-[#53538c] transition"
            aria-label="Back"
          >
            ←
          </button>

        
          <span className="text-gray-100 truncate max-w-[240px]"> 
         
            {title}
          </span>

         

 
 {/* <button onClick={onHome} className={tabClass("home")}>
  <FolderSync size={18}
  strokeWidth={1.5}

className="text-[#FFD600]"



 />
  <span>Change Project</span>
  {activeBar("home")}
</button> */}

{!isSampleUser && (
<button onClick={onHome} className={tabClass("home")}>
  <FolderSync
    size={18}
    strokeWidth={1.5}
    className="text-[#FFD600]"
  />
  <span>Change Project</span>
  {activeBar("home")}
</button>
)}
         
        {/*   {projectId !== null && projectId !== undefined && (
  <button
  onClick={openEditProject}
  disabled={loadingProject}
  className={tabClass("home")}
>
  <FilePen size={18} 
  strokeWidth={1.5}
className="text-[#FFD600]"
/>
  <span>Edit Project Details</span>
</button>
)} */}
{!isSampleUser &&
 projectId !== null &&
 projectId !== undefined && (
  <button
    onClick={openEditProject}
    disabled={loadingProject}
    className={tabClass("home")}
  >
    <FilePen
      size={18}
      strokeWidth={1.5}
      className="text-[#FFD600]"
    />
    <span>Edit Project Details</span>
  </button>
)}
        </div>

        <nav className="hidden md:flex items-stretch h-full ml-6 flex-1 justify-center">

          {!isSampleUser && (
  <>
          {/* <button onClick={onDashboard} className={tabClass("dashboard")}>
            🏗️ Model
            {activeBar("dashboard")}
          </button>
  */}
  <button onClick={onDashboard} className={tabClass("dashboard")}>
  <Blocks size={18} 
  strokeWidth={1.5}
//className="text-white"
className="text-[#FFD600]"

/>
  <span>Model</span>
  {activeBar("dashboard")}
</button>
  


            {/* <button onClick={onFourth} className={tabClass("fourth")}>
  📊 Parameters
  {activeBar("fourth")}
</button> */}
<button onClick={onFourth} className={tabClass("fourth")}>
  <RulerDimensionLine size={18}
  strokeWidth={1.5}
//className="text-white"
className="text-[#FFD600]"

/>
  <span>Measures</span>
  {activeBar("fourth")}
</button>

          {/* <button onClick={onFifth} className={tabClass("fifth")}>
  📌 Marks Table
  {activeBar("fifth")}
</button> */}
<button onClick={onFifth} className={tabClass("fifth")}>
  
  <SlidersHorizontal size={18}
  strokeWidth={1.5}
//className="text-white" 
className="text-[#FFD600]"

/>
  <span>Matrix</span>
  {activeBar("fifth")}
</button>
</>
          )}


         <button onClick={onThird} className={tabClass("third")}>
  <Grid3x3 size={18} 
  strokeWidth={1.5}
//className="text-white"
className="text-[#FFD600]"
/>
  <span>NLBD</span>
  {activeBar("third")}
</button>


          <button onClick={onSecond} className={tabClass("second")}>
  <GitCompare size={18} 
  strokeWidth={1.5}
//className="text-white"
className="text-[#FFD600]"
/>
  <span>Summary</span>
  {activeBar("second")}
</button>
        
        </nav>

        <div className="flex items-center gap-4 ml-4 whitespace-nowrap">
         
          {!isSampleUser && (
          <div className="flex items-center gap-2 text-gray-300">
  <HardHat size={18} 
  strokeWidth={1.5}

className="text-[#FFD600]"
  />
  <span> {userName || "User"}</span>
</div>
          )}
          {/* <button
            onClick={onLogout}
           
            className="h-12 px-4 text-gray-300 hover:text-white hover:bg-[#070730] transition-colors duration-150"
          >
            Logout
          </button> */}
          <button
  onClick={onLogout}
  //className="h-12 px-4 text-gray-300 hover:text-white hover:bg-[#070730] transition-colors duration-150 flex items-center gap-2"
  className="h-12 px-4 text-gray-300 hover:text-white hover:bg-[#53538c] transition-colors duration-150 flex items-center gap-2"
>
  <LogOut size={18} 
  strokeWidth={1.5}
//className="text-white"
className="text-[#FFD600]"/>
  <span>Logout</span>
</button>
        </div>
      </header>

      {showEditModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
         

          <div
  className="bg-white p-6 rounded-2xl w-full max-w-md shadow-2xl"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>
            <h2 className=" mb-4">
              Edit Project</h2>

            <div className="mb-3">
             
              <label className="block text-gray-700 mb-1">
                Project Name
              </label>
              <input
                type="text"
                className="w-full border p-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
                value={editForm.projectName}
                onChange={(e) =>
                  setEditForm({ ...editForm, projectName: e.target.value })
                }
              />
            </div>

            <div className="mb-3">
              <label className="block  font-medium text-gray-700 mb-1">
                Project Description
              </label>
              <input
                type="text"
                className="w-full border p-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
                value={editForm.projectDescription}
                onChange={(e) =>
                  setEditForm({
                    ...editForm,
                    projectDescription: e.target.value,
                  })
                }
              />
            </div>

            <div className="mb-3">
              <label className="block font-medium text-gray-700 mb-1">
                Start Date
              </label>
              <input
                type="date"
                className="w-full border p-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
                value={editForm.startDate}
                onChange={(e) =>
                  setEditForm({ ...editForm, startDate: e.target.value })
                }
              />
            </div>

            <div className="mb-3">
              <div className="flex items-center justify-between mb-2">
                <label className="block  font-medium text-gray-700">
                  Project Image
                </label>

                {(editForm.imageUrl || editForm.imagePreviewUrl) && (
                  <button
                    type="button"
                    onClick={handleDeleteImage}
                    disabled={deletingImage}
                    className=" px-3 py-1 rounded-md bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
                  >
                    {deletingImage ? "Deleting..." : "Delete Image"}
                  </button>
                )}
              </div>

              {imageLoading ? (
                <div className="w-full h-24 border rounded-lg bg-gray-50 flex items-center justify-center  text-gray-500">
                  Loading image...
                </div>
              ) : editForm.imagePreviewUrl && !editForm.image ? (
                <img
                  src={editForm.imagePreviewUrl}
                  alt="Project"
                  className="w-24 h-24 object-cover rounded-lg mb-3 border"
                />
              ) : editForm.imageUrl && !editForm.image ? (
                <div className="mb-3">
                  <img
                    src={editForm.imageUrl}
                    alt="Project"
                    className="w-24 h-24 object-cover rounded-lg border"
                  />
                  <div className=" text-gray-500 mt-1 break-all">
                    {editForm.imageUrl}
                  </div>
                </div>
              ) : null}

              {editForm.image && (
                <img
                  src={URL.createObjectURL(editForm.image)}
                  alt="New Project"
                  className="w-24 h-24 object-cover rounded-lg mb-3 border"
                />
              )}

              <input
                type="file"
                accept="image/*"
                className="w-full border p-2 rounded-lg bg-white"
                onChange={(e) =>
                  setEditForm({
                    ...editForm,
                    image: e.target.files?.[0] || null,
                  })
                }
              />
            </div>

            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => {
                  setShowEditModal(false);
                  resetEditForm();
                }}
                className="bg-gray-300 px-4 py-2 rounded-lg"
              >
                Cancel
              </button>

              <button
                onClick={handleUpdateProject}
                disabled={saving}
                className="bg-green-600 text-white px-4 py-2 rounded-lg disabled:opacity-60"
              >
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AppHeader;